import * as React from 'react';

import * as styles from './Controls.css';

export const Controls = ({
  children,
  maxWidth = 300,
}: React.PropsWithChildren<{ maxWidth?: number }>): React.JSX.Element => {
  return (
    <div
      className={styles['container']}
      style={maxWidth ? ({ '--button-max-width': `${maxWidth}px` } as React.CSSProperties) : undefined}
    >
      {React.Children.map(children, (item, index) => {
        if (!item) {
          return null;
        }

        return (
          <div key={index} className={styles['button']}>
            {item}
          </div>
        );
      })}
    </div>
  );
};
